import React from 'react';

import { api } from '../../../../../core/api';
import CompanyTabContent from '../shared/CompanyTabContent';
import DynamicMatrixDataTable from '../shared/DynamicMatrixDataTable';
import { useCompanyRawFinTabLoader } from '../shared/useCompanyTabLoader';

const CompanyRawFinancials: React.FC = () => {
  const { data, isLoading } = useCompanyRawFinTabLoader(api.company.getRawFinancialsData);

  return (
    <CompanyTabContent isLoading={isLoading}>
      <DynamicMatrixDataTable
        title={'raw'}
        translationsScope={'companies:companyFinancials'}
        data={data?.rawFinancialDetails}
        translation={data?.translations}
        showCurrency={true}
      />
    </CompanyTabContent>
  );
};

export default CompanyRawFinancials;
